const WORKOUT_SECTIONS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

export default WORKOUT_SECTIONS_KEY
